export default __webpack_public_path__ + "static/media/qr-code-rogers.b78deab4.svg";